/* global G */
const recent = obj => (...args) => {
  const model = obj[G.MODEL]
  const settingsAdapter = obj[G.ADAPTER][G.SETTINGS]

  const { model: modelName } = model[G.CONFIGURATION]
  const type = modelName.split('/')[0].toLowerCase()
  const key = model[G.STATE][G.REF]

  settingsAdapter[G.API].setRecent({ key, value: { type } })

  return args
}

export default recent
